import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Cpu = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      fill={fill}
      {...rest}
    >
      <path d="M5.333 3.201A.333.333 0 0 1 5 2.868V1.534a.333.333 0 0 1 .667 0v1.334a.333.333 0 0 1-.334.333ZM10.667 3.201a.333.333 0 0 1-.333-.333V1.534a.333.333 0 1 1 .667 0v1.334a.333.333 0 0 1-.334.333ZM8.001 3.201a.333.333 0 0 1-.333-.333V1.534a.333.333 0 0 1 .667 0v1.334A.333.333 0 0 1 8 3.2ZM15.335 11.868H14a.333.333 0 1 1 0-.667h1.334a.333.333 0 1 1 0 .667ZM15.335 6.534H14a.333.333 0 1 1 0-.667h1.334a.333.333 0 0 1 0 .667ZM15.335 9.202H14a.333.333 0 1 1 0-.667h1.334a.333.333 0 1 1 0 .667ZM2 11.868H.668a.333.333 0 1 1 0-.667h1.334a.333.333 0 1 1 0 .667ZM2 6.534H.668a.333.333 0 0 1 0-.667h1.334a.333.333 0 0 1 0 .667ZM2 9.202H.668a.333.333 0 0 1 0-.667h1.334a.333.333 0 1 1 0 .667ZM5.333 16.533A.333.333 0 0 1 5 16.2v-1.333a.333.333 0 1 1 .667 0V16.2a.333.333 0 0 1-.334.333ZM10.667 16.533a.333.333 0 0 1-.333-.333v-1.333a.333.333 0 1 1 .667 0V16.2a.333.333 0 0 1-.334.333ZM8.001 16.533a.333.333 0 0 1-.333-.333v-1.333a.333.333 0 1 1 .667 0V16.2a.333.333 0 0 1-.334.333Z" />
      <path d="M3.335 2.535h9.333a1.668 1.668 0 0 1 1.666 1.667v9.333a1.669 1.669 0 0 1-1.666 1.666H3.335a1.669 1.669 0 0 1-1.667-1.666V4.202a1.669 1.669 0 0 1 1.667-1.667Zm9.333 12a1 1 0 0 0 1-1V4.202a1 1 0 0 0-1-1H3.335a1 1 0 0 0-1 1v9.333a1 1 0 0 0 1 1h9.333Z" />
      <path d="M10.667 10.201a1.333 1.333 0 1 1 0 2.666 1.333 1.333 0 0 1 0-2.666Zm0 2a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z" />
    </svg>
  );
};

Cpu.category = 'product';

Cpu.displayName = 'Cpu';
